import { Link, useLocation } from 'react-router-dom';
import { ItemType } from 'antd/es/breadcrumb/Breadcrumb';
import { ArticleTypeEnum, WithArticleTypeProps } from './types';
import { ArticleType } from '../../../store/article/list';

/**
 * Custom hook to determine the articleType by inspecting the URL pathname.
 * It looks for segments like '/blog/', '/history/', etc., in the path.
 */
export const useArticleTypeParam = (): WithArticleTypeProps => {
  // 1. Get the current URL path (e.g., "/articles/history/create")
  const { pathname } = useLocation();

  // 2. Get the array of all possible valid article types from your enum
  const validTypes = Object.values(ArticleTypeEnum); // Result: ['blog', 'history', 'psychology']

  // 3. Find the first valid type that is included in the URL pathname
  const foundType = validTypes.find((type) => pathname.includes(`/${type}`));

  // 4. Return the found type, or default to 'blog' if no match is found
  const articleType = (foundType || ArticleTypeEnum.BLOG) as ArticleType;

  return { articleType };
};

export const getArticleInnerMenuItems = (): ItemType[] => (
  [{
    title: 'Articles',
    menu: {
      items: Object.values(ArticleTypeEnum).map((type) => ({
        key: type,
        label: (
          <Link to={`/articles/${type}`} className="capitalize">
            {type}
          </Link>
        ),
      })),
    },
  }]
);
